import React, { forwardRef } from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, Text, TextStyle, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  children: React.ReactNode;
  isHovered?: boolean;
  isSelected?: boolean;
  prefixComponent?: React.ReactNode;
  textStyle?: StyleProp<TextStyle>;
}

export const Tag = forwardRef<View, Props>(
  ({ children, isHovered, isSelected, prefixComponent, textStyle }, ref) => {
    const [styles] = useStyles();
    return (
      <View
        ref={ref}
        style={[
          styles.tag,
          isSelected ? styles.tagSelected : null,
          isHovered ? styles.tagHovered : null,
        ]}
        testID="tag"
      >
        {prefixComponent ? prefixComponent : null}
        <Text
          numberOfLines={1}
          style={[TYPOGRAPHY.listSubtitle, styles.tagText, textStyle]}
        >
          {children}
        </Text>
      </View>
    );
  },
);

const useStyles = createStyles((theme) => ({
  tag: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.secondary.default,
    borderRadius: 8,
    borderWidth: 0,
    flexDirection: 'row',
    gap: 8,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  tagHovered: {
    backgroundColor: theme.sk.color.bg.secondary.default,
  },
  tagSelected: {
    backgroundColor: theme.sk.color.bg.secondary.hover,
  },
  tagText: {
    color: theme.colors.inactiveTextPMC,
    flex: 1,
    lineHeight: 16,
  },
}));
